import React, { useState, useEffect } from 'react';
import {
  Grid,
  FormControl,
  FormGroup,
  Paper,
  TextField,
  Typography,
  Button,
  createMuiTheme,
  InputLabel,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import Alert from './Alert';
import PhoneInput from '../atoms/PhoneInput';
import StatusSelect from '../atoms/StatusSelect';
import { getToken } from '../../services/auth';

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '100%',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
  },
  root: {
    //   width: '100%',
    //   margin: theme.spacing(2),
    backgroundColor: 'gray',
    //   '& > *': {
    //     margin: theme.spacing(1),
    //   },
  },
  formGroup: { marginTop: theme.spacing(1) },
  countPaper: {},
  // textField: { backgroundColor: 'white' },
}));
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#00c73c',
      contrastText: 'white',
    },
  },
});

const AdminReservationForm = ({ onSubmit, onClose, editData }) => {
  const [isTrySubmit, setIsTrySubmit] = useState(false);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [content, setContent] = useState('');
  const [status, setStatus] = useState('');

  const [isEditMode, setIsEditMode] = useState(!!editData);

  // alert
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertTitle, setAlertTitle] = useState('');

  const showAlert = (_alertTitle, _alertContent) => {
    setAlertTitle(_alertTitle);
    setAlertContent(_alertContent);
    setIsAlertOpen(true);
  };

  const classes = useStyles(theme);

  useEffect(() => {
    if (editData) {
      setName(editData.name);
      setPhone(editData.phone);
      setContent(editData.content);
      setStatus(editData.status);
      setIsEditMode(true);
    }
  }, [editData]);

  const resetFormData = () => {
    setIsTrySubmit(false);
    setName('');
    setPhone('');
    setContent('');
  };

  const handleInputChange = (event) => {
    const { value } = event.target;
    switch (event.target.id) {
    case 'input-name': {
      setName(value);
      break;
    }
    case 'input-phone': {
      setPhone(value);
      break;
    }
    case 'input-content': {
      setContent(value);
      break;
    }

    default: {
      break;
    }
    }
  };

  const handleStatusChange = (id, value) => {
    setStatus(value);
  };

  const handleSubmit = async () => {
    if (typeof window === 'undefined') return;

    window.grecaptcha.ready(async () => {
      const token = getToken();

      const recaptchaToken = await window.grecaptcha.execute(
        `${process.env.REACT_APP_RECAPTCHA_KEY}`,
        {
          action: 'create_reservation',
        },
      );
      setIsTrySubmit(true);

      // validation check
      if (name.trim() === '') {
        showAlert('에러', '필수항목을 확인해주세요');
        return;
      }
      if (phone.trim() === '') {
        showAlert('에러', '필수항목을 확인해주세요');
        return;
      }
      if (content.trim() === '') {
        showAlert('에러', '필수항목을 확인해주세요');
        return;
      }

      const normalizedPhone = phone.replace(/_/g, '').replace(/-/g, '');
      if (normalizedPhone.length !== 10 && normalizedPhone.length !== 11) {
        showAlert('에러', '전화번호를 확인해주세요');
        return;
      }

      const formData = new FormData();
      formData.append('name', name);
      formData.append('phone', phone);
      formData.append('title', '온라인 상담 신청합니다.');
      formData.append('content', content);
      formData.append('status', status);
      formData.append('is_agree_policy', '1');
      formData.append('g-recaptcha-response', recaptchaToken);

      // form 데이터를 json으로 변경한다
      const data = {};
      formData.forEach((value, key) => {
        data[key] = value;
      });
      const json = JSON.stringify(data);
      console.log('handleSubmit -> json', json);

      // submit to Server
      let response;
      if (isEditMode) {
        response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/admin/reservation/${editData.id}`,
          {
            method: 'PUT',
            mode: 'cors',
            // cache: 'no-cache',
            // credentials: 'omit',
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              Authorization: `Bearer ${token}`,
            },
            body: json,
          },
        );
      } else {
        response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/admin/reservation`,
          {
            method: 'POST',
            mode: 'cors',
            // cache: 'no-cache',
            // credentials: 'omit',
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              Authorization: `Bearer ${token}`,
            },
            body: json,
          },
        );
      }

      if (
        response.status === 200
        || response.status === 201
        || response.status === 204
      ) {
        showAlert('성공');
      } else if (response.status === 406) {
        showAlert('에러', '입력 내용을 확인해주세요.');
        return;
      } else {
        showAlert(
          '에러',
          '온라인 상담 신청에 실패했습니다. 고객센터에 문의부탁드립니다.',
        );
        return;
      }
      resetFormData();
      if (onSubmit) onSubmit();
    });
  };

  const handleDelete = async () => {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('phone', phone);

    const data = {};
    formData.forEach((value, key) => {
      data[key] = value;
    });
    const json = JSON.stringify(data);

    if (typeof window === 'undefined') return;

    const isConfirm = window.confirm('정말 지우시겠습니까?');

    if (!isConfirm) {
      return;
    }

    const token = getToken();

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/admin/reservation/${editData.id}`,
      {
        method: 'DELETE',
        mode: 'cors',
        // cache: 'no-cache',
        // credentials: 'omit',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${token}`,
        },
        body: json,
      },
    );

    if (
      response.status === 200
      || response.status === 201
      || response.status === 204
    ) {
      window.alert('성공');
    } else {
      window.alert('실패했습니다. 고객센터에 문의부탁드립니다.');
      return;
    }
    resetFormData();
    if (onSubmit) onSubmit();
  };

  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
    <>
      <Paper className={classes.paper}>
        <Typography>
          <span style={{ color: 'red' }}>
            - 관리자용 상세보기/수정 화면입니다.
            {' '}
            <br />
            - 하단 상태변경은
            표에서도 가능합니다.
          </span>
        </Typography>
        <form className={classes.form} noValidate autoComplete="off">
          <FormGroup className={classes.formGroup}>
            <FormControl>
              <TextField
                required
                type="text"
                label="이름"
                id="input-name"
                value={name}
                variant="outlined"
                onChange={handleInputChange}
                error={isTrySubmit && name === ''}
                helperText={
                  isTrySubmit && name === '' ? '성명을 입력해주세요' : ''
                }
              />
            </FormControl>
          </FormGroup>
          <FormGroup className={classes.formGroup}>
            <FormControl>
              <PhoneInput
                required
                error={isTrySubmit && phone === ''}
                helperText={
                  isTrySubmit && phone === '' ? '연락처를 입력해주세요' : ''
                }
                id="input-phone"
                value={phone}
                onChange={handleInputChange}
                variant="outlined"
              />
            </FormControl>
          </FormGroup>
          <FormGroup className={classes.formGroup}>
            <FormControl className={classes.formControl}>
              <TextField
                id="input-content"
                label="내용"
                multiline
                rows="4"
                variant="outlined"
                value={content}
                onChange={handleInputChange}
              />
            </FormControl>
          </FormGroup>
          <FormGroup className={classes.formGroup}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="input-status-label">상태</InputLabel>
              <StatusSelect
                selectProps={{
                  labelId: 'input-status-label',
                }}
                defaultValue={status}
                onChangeValue={handleStatusChange}
              />
            </FormControl>
          </FormGroup>
          <Grid
            container
            alignItems="center"
            spacing={1}
            style={{ marginTop: '10px' }}
          >
            <Grid item xs={12}>
              <Button
                fullWidth
                color="primary"
                size="large"
                variant="contained"
                onClick={handleSubmit}
              >
                저장
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                color="secondary"
                size="large"
                variant="contained"
                onClick={handleDelete}
              >
                삭제
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                color="default"
                size="large"
                variant="contained"
                onClick={handleClose}
              >
                닫기
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
      <Alert
        open={isAlertOpen}
        setIsOpen={setIsAlertOpen}
        title={alertTitle}
        content={alertContent}
      />
    </>
  );
};

AdminReservationForm.propTypes = {};

export default AdminReservationForm;
